const devConfig = () => {
    return {
        environment: 'dev',
        domain: 'https://fe.app.dev.ils.qloudx.com/',
        hostname: 'https://fe.app.dev.ils.qloudx.com',
        albURL: 'reebok-labelling-fe-lb-27214977.us-east-2.elb.amazonaws.com',
        gateway: 'https://coyabdyrf3.execute-api.us-east-2.amazonaws.com',
        gatewayPath: '/dev/labelling',

        oneLogin: {
            authority: "https://qloudx.onelogin.com/oidc/2",
            loginURL: "https://qloudx.onelogin.com/",
            logout: "https://qloudx.onelogin.com/oidc/2/logout",
            clientId: "80a0bc50-0ee9-013e-fbef-08d788aaa55c248475",
            redirectURI: "https://fe.app.dev.ils.qloudx.com/redirect"
        }
    }
}

export default devConfig
